export const fuelAdvancesEn = {
  //Start Michael
  FUEL_ADVANCE: 'Fuel Advance',
  FUEL_ADVANCES: 'Fuel Advances',
  FUEL_ADVANCES_WERE_SELECTED_FOR_THIS_ACTION: 'fuel advances were selected for this action',
  FUEL_ADVANCE_AMOUNT: 'Fuel Advance Amount',
  FUEL_ADVANCE_BALANCE: 'Balance',
  TOTAL_FUEL_ADVANCE_AMOUNT: 'Total Fuel Advance Amount',
  TOTAL_FUEL_ADVANCE_FEES: 'Total Fuel Advance Fees',
  FUEL_ADVANCE_FEE_AMOUNT: 'Fuel Advance Fee Amount',
  FUEL_ADVANCE_FEE_PERCENTAGE: 'Fuel Advance Fee Percentage',
  FUEL_ADVANCE_AMOUNT_CANNOT_GREATER_INVOICE_AMOUNT: 'Fuel Advance Amount cannot be greater than Invoice Amount',
  FUEL_ADVANCE_FEE_AMOUNT_CANNOT_GREATER_FUEL_ADVANCE_AMOUNT:
    'Fuel Advance Fee Amount cannot be greater than Fuel Advance Amount',
  FUEL_ADVANCE_CREATED_SUCCESSFULLY: 'Fuel Advance created successfully',
  FUEL_ADVANCE_UPDATED_SUCCESSFULLY: 'Fuel Advance updated successfully',
  FUEL_ADVANCE_NOTES_UPDATED_SUCCESSFULLY: 'Fuel Advance notes updated successfully',
  FUEL_ADVANCE_FEE_OR_PERCENTAGE_REQUIRED:
    'Please enter either "Fuel Advance Fee Amount" or "Fuel Advance Fee Percentage"',
  ZERO_OUT_PAYMENT_FEE: 'Zero Out Payment Fee',
  FUEL_ADVANCES_APPROVED_FOR_FUNDING_SUCCESSFULLY: 'Fuel Advances approved for funding successfully!',
  APPROVE_FOR_FUNDING_FUEL_ADVANCE_CONFIRMATION: 'Are you sure you want to approve these fuel advances for funding?',
  TOTAL_FUEL_ADVANCES: 'Total Fuel Advances',
  DELIVERY_DATE: 'Delivery Date',
  FUEL_ADVANCE_TYPE: 'Fuel Advance Type',
  FUEL_ADVANCE_TYPES: {
    INVOICE: 'Invoice',
    CREDIT: 'Credit',
  },
  REGULAR: 'Regular',
  FUEL_ADVANCES_CREDIT: 'Fuel Advances Credit',
  FUEL_ADVANCE_CSV_SUCCESS: 'Fuel Advance CSV file uploaded successfully',
  FUEL_ADVANCES_INVOICE: 'Fuel Advances Invoice',
  REJECT_FUEL_ADVANCE: 'Reject Fuel Advance',
  //End Michael
  //Start Fabian
  DOCUMENTS_FUEL_ADVANCE_UPLOADED_SUCCESSFULLY: 'Documents for Fuel Advance uploaded successfully',
  //End Fabian
  //Start Esteban
  FUEL_ADVANCE_REJECT_CONFIRMATION: 'Are you sure you want to reject these fuel advances?',
  FUEL_ADVANCE_PENDING_CONFIRMATION: 'Are you sure you want to move these fuel advances to pending?',
  FUEL_ADVANCE_REJECTED_SUCCESSFULLY: 'Fuel Advance/s rejected successfully!',
  FUEL_ADVANCE_PENDING_SUCCESSFULLY: 'Fuel Advance/s moved to pending successfully!',
  FUEL_ADVANCE_MOVE_TO_REJECTED: 'Move to Rejected',
  FUEL_ADVANCE_MOVE_TO_PENDING: 'Move to Pending',
  CLIENT_INVOICES: 'Invoices (Clients)',
  BROKER_INVOICES: 'Invoices (Brokers)',
  //End Esteban
  //Start Fco
  FUEL_ADVANCE_MAX_AMOUNT_INFO: 'Max amount: {maxAmount} ({percent}%)',
  FUEL_ADVANCE_MIN_FEE_INFO: 'Min fee: {minFee}',
  FUEL_ADVANCE_MAX_AMOUNT_WARNING: "Fuel Advance Amount exceeds the client's limit",
  FUEL_ADVANCE_MIN_FEE_WARNING: "Fuel Advance Fee Amount is below the client's limit",
  FUEL_ADVANCE_STATUS: 'Fuel Advance Status',
  //End Fco
  //Start Patricio
  FUEL_ADVANCE_CHARGEBACK: 'Fuel Advance Chargeback',
  ISSUE_DATE: 'Issue Date',
  //End Patricio
  //Start Approve All Fuel Advances
  APPROVE_ALL_FUEL_ADVANCES: 'Approve All',
  APPROVE_ALL_FUEL_ADVANCES_CONFIRMATION_TITLE: 'Are you sure you want to approve all pending fuel advances for all clients?',
  APPROVE_ALL_FUEL_ADVANCES_CONFIRMATION_BODY:
    "This will approve for funding every pending fuel advance across all clients using each client's default funding instruction.",
  APPROVE_ALL_FUEL_ADVANCES_PROGRESS: 'Approving client {current} of {total} — {clientName}',
  APPROVE_ALL_FUEL_ADVANCES_SUCCESS_SUMMARY: 'Approved {count} of {total} clients.',
  APPROVE_ALL_FUEL_ADVANCES_ERROR_TITLE: 'Approve All could not finish',
  APPROVE_ALL_FUEL_ADVANCES_ERROR_BODY: 'An error occurred while approving fuel advances for {clientName}: {message}',
  APPROVE_ALL_FUEL_ADVANCES_LIST_CLIENTS_ERROR: 'Could not load the list of pending clients: {message}',
  APPROVE_ALL_FUEL_ADVANCES_NO_DEFAULT_FUNDING_INSTRUCTION: '{clientName} does not have a default funding instruction configured.',
  APPROVE_ALL_FUEL_ADVANCES_NO_PENDING: 'There are no pending fuel advances to approve.',
  //End Approve All Fuel Advances
  //Start Active Funding Chargeback
  FUNDING_CHARGEBACK: 'Funding Chargeback',
  FUNDING_CHARGEBACK_ACTIVE_NOTE: 'Shows this Fuel Advance\'s currently active funding chargeback.',
  ACTIVE_FUNDING_CHARGEBACK_AMOUNT: 'Chargeback Amount',
  ACTIVE_FUNDING_CHARGEBACK_STATUS: 'Chargeback Status',
  ACTIVE_FUNDING_CHARGEBACK_BATCH: 'Batch',
  NO_ACTIVE_FUNDING_CHARGEBACK: 'This Fuel Advance has no active funding chargeback.',
  FUNDING_CHARGEBACK_STATUSES: {
    PENDING: 'Pending',
    IN_QUEUE: 'In Queue',
    COMPLETED: 'Completed',
  },
  FUEL_ADVANCE_HAS_ACTIVE_FUNDING_CHARGEBACK_INFO:
    'This Fuel Advance already has an active funding chargeback. Open its details and check the {section} section for more information.',
  FUEL_ADVANCES_HAVE_ACTIVE_FUNDING_CHARGEBACK_INFO:
    'One or more of the selected Fuel Advances already have an active funding chargeback. Open their details and check the {section} section for more information.',
  //End Active Funding Chargeback
}

export const fuelAdvancesEs: typeof fuelAdvancesEn = {
  //Start Michael
  FUEL_ADVANCE: 'Anticipo de combustible',
  FUEL_ADVANCES: 'Anticipos de combustible',
  FUEL_ADVANCES_WERE_SELECTED_FOR_THIS_ACTION: 'anticipos de combustible fueron seleccionados para esta acción',
  FUEL_ADVANCE_AMOUNT: 'Monto del anticipo de combustible',
  FUEL_ADVANCE_BALANCE: 'Saldo',
  TOTAL_FUEL_ADVANCE_AMOUNT: 'Monto total del anticipo de combustible',
  TOTAL_FUEL_ADVANCE_FEES: 'Total de tarifas de anticipo de combustible',
  FUEL_ADVANCE_FEE_AMOUNT: 'Monto de la tarifa de anticipo de combustible',
  FUEL_ADVANCE_FEE_PERCENTAGE: 'Porcentaje de tarifa de anticipo de combustible',
  FUEL_ADVANCE_AMOUNT_CANNOT_GREATER_INVOICE_AMOUNT:
    'El monto del anticipo de combustible no puede ser mayor que el monto de la factura',
  FUEL_ADVANCE_FEE_AMOUNT_CANNOT_GREATER_FUEL_ADVANCE_AMOUNT:
    'El monto de la tarifa de anticipo de combustible no puede ser mayor que el monto del anticipo de combustible',
  FUEL_ADVANCE_CREATED_SUCCESSFULLY: 'Anticipo de combustible creado correctamente',
  FUEL_ADVANCE_UPDATED_SUCCESSFULLY: 'Anticipo de combustible actualizado correctamente',
  FUEL_ADVANCE_NOTES_UPDATED_SUCCESSFULLY: 'Notas de anticipo de combustible actualizadas correctamente',
  FUEL_ADVANCE_FEE_OR_PERCENTAGE_REQUIRED:
    'Ingrese "Monto de la tarifa de anticipo de combustible" o "Porcentaje de tarifa de anticipo de combustible"',
  ZERO_OUT_PAYMENT_FEE: 'Tarifa de pago cero',
  FUEL_ADVANCES_APPROVED_FOR_FUNDING_SUCCESSFULLY: '¡Anticipos de combustible aprobados para financiamiento con éxito!',
  APPROVE_FOR_FUNDING_FUEL_ADVANCE_CONFIRMATION:
    '¿Estás seguro de que deseas aprobar estos anticipos de combustible para su financiamiento?',
  TOTAL_FUEL_ADVANCES: 'Total de anticipos de combustible',
  DELIVERY_DATE: 'Fecha de entrega',
  FUEL_ADVANCE_TYPE: 'Tipo de anticipo de combustible',
  FUEL_ADVANCE_TYPES: {
    INVOICE: 'Factura',
    CREDIT: 'Crédito',
  },
  REGULAR: 'Regular',
  FUEL_ADVANCES_CREDIT: 'Crédito de anticipos de combustible',
  FUEL_ADVANCE_CSV_SUCCESS: 'Archivo CSV de anticipos de combustible cargado correctamente',
  FUEL_ADVANCES_INVOICE: 'Factura de anticipos de combustible',
  REJECT_FUEL_ADVANCE: 'Rechazar anticipo de combustible',
  //End Michael
  //Start Fabian
  DOCUMENTS_FUEL_ADVANCE_UPLOADED_SUCCESSFULLY: 'Documentos para anticipo de combustible cargados correctamente',
  //End Fabian
  //Start Esteban
  FUEL_ADVANCE_REJECT_CONFIRMATION: '¿Estás seguro de que deseas rechazar estos anticipos de combustible?',
  FUEL_ADVANCE_PENDING_CONFIRMATION: '¿Estás seguro de que deseas poner estos anticipos de combustible en pendiente?',
  FUEL_ADVANCE_REJECTED_SUCCESSFULLY: 'Anticipo de combustible rechazado correctamente',
  FUEL_ADVANCE_PENDING_SUCCESSFULLY: 'Anticipo de combustible pendiente correctamente',
  FUEL_ADVANCE_MOVE_TO_REJECTED: 'Mover a Rechazado',
  FUEL_ADVANCE_MOVE_TO_PENDING: 'Mover a Pendiente',
  CLIENT_INVOICES: 'Facturas de clientes',
  BROKER_INVOICES: 'Facturas de corredores',
  //End Esteban
  //Start Fco
  FUEL_ADVANCE_MAX_AMOUNT_INFO: 'Monto máximo: {maxAmount} ({percent}%)',
  FUEL_ADVANCE_MIN_FEE_INFO: 'Tarifa mínima: {minFee}',
  FUEL_ADVANCE_MAX_AMOUNT_WARNING: 'El monto del anticipo de combustible excede el límite del cliente',
  FUEL_ADVANCE_MIN_FEE_WARNING:
    'El monto de la tarifa de anticipo de combustible está por debajo del límite del cliente',
  FUEL_ADVANCE_STATUS: 'Estado del anticipo de combustible',
  //End Fco
  //Start Patricio
  FUEL_ADVANCE_CHARGEBACK: 'Cargo por anticipo de combustible',
  ISSUE_DATE: 'Fecha de emisión',
  //End Patricio
  //Start Approve All Fuel Advances
  APPROVE_ALL_FUEL_ADVANCES: 'Aprobar todos',
  APPROVE_ALL_FUEL_ADVANCES_CONFIRMATION_TITLE:
    '¿Estás seguro de que deseas aprobar todos los anticipos de combustible pendientes de todos los clientes?',
  APPROVE_ALL_FUEL_ADVANCES_CONFIRMATION_BODY:
    'Esto aprobará para financiamiento todos los anticipos de combustible pendientes de todos los clientes, usando la instrucción de financiación predeterminada de cada cliente.',
  APPROVE_ALL_FUEL_ADVANCES_PROGRESS: 'Aprobando cliente {current} de {total} — {clientName}',
  APPROVE_ALL_FUEL_ADVANCES_SUCCESS_SUMMARY: 'Clientes aprobados: {count} de {total}.',
  APPROVE_ALL_FUEL_ADVANCES_ERROR_TITLE: 'Aprobar todos no pudo completarse',
  APPROVE_ALL_FUEL_ADVANCES_ERROR_BODY:
    'Ocurrió un error al aprobar los anticipos de combustible de {clientName}: {message}',
  APPROVE_ALL_FUEL_ADVANCES_LIST_CLIENTS_ERROR: 'No se pudo cargar la lista de clientes pendientes: {message}',
  APPROVE_ALL_FUEL_ADVANCES_NO_DEFAULT_FUNDING_INSTRUCTION:
    '{clientName} no tiene una instrucción de financiación predeterminada configurada.',
  APPROVE_ALL_FUEL_ADVANCES_NO_PENDING: 'No hay anticipos de combustible pendientes para aprobar.',
  //End Approve All Fuel Advances
  //Start Active Funding Chargeback
  FUNDING_CHARGEBACK: 'Chargeback de financiamiento',
  FUNDING_CHARGEBACK_ACTIVE_NOTE: 'Muestra el chargeback de financiamiento actualmente activo de este anticipo de combustible.',
  ACTIVE_FUNDING_CHARGEBACK_AMOUNT: 'Monto del chargeback',
  ACTIVE_FUNDING_CHARGEBACK_STATUS: 'Estado del chargeback',
  ACTIVE_FUNDING_CHARGEBACK_BATCH: 'Batch',
  NO_ACTIVE_FUNDING_CHARGEBACK: 'Este anticipo de combustible no tiene un chargeback de financiamiento activo.',
  FUNDING_CHARGEBACK_STATUSES: {
    PENDING: 'Pendiente',
    IN_QUEUE: 'En cola',
    COMPLETED: 'Completado',
  },
  FUEL_ADVANCE_HAS_ACTIVE_FUNDING_CHARGEBACK_INFO:
    'Este anticipo de combustible ya tiene un chargeback de financiamiento activo. Abrí su detalle y revisá la sección {section} para más información.',
  FUEL_ADVANCES_HAVE_ACTIVE_FUNDING_CHARGEBACK_INFO:
    'Uno o más de los anticipos de combustible seleccionados ya tienen un chargeback de financiamiento activo. Abrí su detalle y revisá la sección {section} para más información.',
  //End Active Funding Chargeback
}
